import { render, staticRenderFns } from "./venta.vue?vue&type=template&id=6de8cf98&"
import script from "./venta.vue?vue&type=script&lang=js&"
export * from "./venta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports